import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import InputField from '../../library/InputField.js';
import FontKeys from '../../FontKeys.js';
import ABCyaPhaser from '@abcya/abcya_phaser';

export default class InputMachine extends AContainer {
  constructor(scene) {
    super(scene);

    this.createMachine();
  }

  createMachine() {
    this.create(75, -163, "Chain");
    this.create(-120, -163, "Chain");

    this.machine = this.create(0, 0, "Round3UI");
    this.wordBg = this.create(-180, 126, "Round3WordTile");

    this.checkBtn = this.create(278, 126, "CheckBtn");
    this.checkBtn.name = "check";

    let size = 32;
    if (gameData.combined[0].present.length >= 7 && gameData.combined[0].present.length < 10) {
      size = 28;
    } else if (gameData.combined[0].present.length >= 10) {
      size = 24;
    }
    this.txt = ABCyaPhaser.Text.addText(0, -3, size, 0xe2d4bc, FontKeys._Tertre_Med, gameData.combined[0].present, this).setResolution(1.5).setShadow(1, 1, '#222');
    this.txt.setPosition(this.wordBg.x, this.wordBg.y - 2);

    this.word = this.scene.addContainer(45, 115,
      new InputField(this.scene, this.create(70, 15, "TextEntryField"), 150, 50, 26, null, true),
      this);
    this.word.lostFocus();
  }

  changeWord() {
    this.scene.playSound("round_3_next_question");

    this.word.text.setText("");
    this.word.updateTextSize();
    this.word.updateCaret();

    this.scene.addTween(this.txt, 750, { scaleY: 0 }, Phaser.Math.Easing.Quadratic.Out,
      () => { this.tweenInWord(); });
  }

  flicker() {
    let randHold = Phaser.Math.Between(0, 500);
    let randRepeat = Phaser.Math.Between(4, 6);

    this.particleSparks();

    this.scene.addTween(this.machine, 50, { alpha: 1, repeat: randRepeat, onRepeat: () => { this.particleSparks() }, yoyo: true, hold: randHold }, Phaser.Math.Easing.Quadratic.InOut);
  }

  getArtifact() {
    this.pulseRefs = ["GetItemPulse1", "GetItemPulse2", "GetItemPulse3", "GetItemPulse4"];
    this.pulses = [];

    for (let n = 0; n < this.pulseRefs.length; n++) {
      let randLength = Phaser.Math.Between(1000, 3000);
      let randDelay = Phaser.Math.Between(0, 1000);
      let randScale = Phaser.Math.FloatBetween(1, 2);

      let pulse = this.create(-25, -50, this.pulseRefs[n]);
      pulse.setScale(0, 0);
      this.pulses.push(pulse);

      this.scene.addTween(pulse, randLength, { scaleX: randScale, scaleY: randScale, alpha: 0, repeat: -1, hold: randDelay }, Phaser.Math.Easing.Quadratic.InOut);
    }

    this.scene.playSound("round_3_correct_answer");

    const artifacts = gameData.artifacts.length > 0 ? gameData.artifacts : gameData.collectedArtifacts;
    this.scene.shuffleArray(artifacts);

    this.artifact = this.scene.add.container(this.x - 25, this.y - 50);
    this.blue1 = this.scene.addImage(0, 0, "GetItemGlow1", this.scene.defaultAtlas, this.artifact);
    this.blue2 = this.scene.addImage(0, 0, "GetItemGlow2", this.scene.defaultAtlas, this.artifact);
    this.art = this.scene.addImage(0, 0, artifacts[0].large, this.scene.defaultAtlas, this.artifact);
    this.art.setScale(.75, .75);
    this.blue1.setScale(1.25, 1.25);
    this.blue2.setScale(1.25, 1.25);
    this.artifact.alpha = 0;
    this.artifact.setScale(0, 0);
    this.artifact.setAngle(-45);
    this.artifact.setDepth(5);

    this.particleBurst();

    if (gameData.artifacts.length > 0) gameData.collectedArtifacts.push(gameData.artifacts.shift());

    this.scene.addTween(this.blue1, 4000, { angle: 180 }, Phaser.Math.Easing.None);
    this.scene.addTween(this.blue2, 4000, { angle: -180 }, Phaser.Math.Easing.None);
    this.scene.addTween(this.artifact, 2000, { y: this.scene.mid.y + 50, scaleX: 1, scaleY: 1, alpha: 1, angle: 0 }, Phaser.Math.Easing.Back.Out);
    this.scene.addDelay(3000, () => { this.tweenOutArtifact(); });
  }

  tweenOutArtifact() {
    for (let n = 0; n < this.pulses.length; n++) {
      this.scene.addTween(this.pulses[n], 1000, { scaleX: 0, scaleY: 0, alpha: 0 }, Phaser.Math.Easing.None,
        () => {
          this.pulses[n].destroy();
          if (n === this.pulses.length - 1) this.pulses = [];
        }
      );
    }

    this.scene.addTween(this.blue1, 1000, { scaleX: 0, scaleY: 0, alpha: 0 }, Phaser.Math.Easing.None);
    this.scene.addTween(this.blue2, 1000, { scaleX: 0, scaleY: 0, alpha: 0 }, Phaser.Math.Easing.None);
    this.scene.addTween(this.artifact, 1000, { x: 1024 + this.artifact.width / 2 }, Phaser.Math.Easing.Back.In,
      () => {
        this.artifact.destroy();
        this.emitter.destroy();
        this.changeWord();
        this.scene.navBar.updateLevel();
      });
  }

  emptyArtifact() {
    for (let n = 0; n < this.pulses.length; n++) {
      this.scene.addTween(this.pulses[n], 1000, { scaleX: 1.25, scaleY: 1.25, alpha: 0 }, Phaser.Math.Easing.None,
        () => {
          this.pulses[n].destroy();
          if (n === this.pulses.length - 1) this.pulses = [];
        }
      );
    }

    this.changeWord();
    this.scene.navBar.updateLevel();
  }

  particleSparks() {
    let randAmount = Phaser.Math.Between(50, 100);

    let emitter = this.scene.add.particles(this.scene.particleAtlas, "yellowBurst").createEmitter({
      x: this.x + this.machine.x - 25,
      y: this.y + this.machine.y - 55,
      speed: { min: -400, max: 400 },
      scale: { start: Phaser.Math.FloatBetween(.5, 1), end: 0 },
      blendMode: 'SCREEN',//{'SCREEN' || "ADD" || "MULTIPLY"},
      lifespan: Phaser.Math.Between(400, 1000),
      gravityY: 300,
      alpha: { min: 0, max: 1 },
      quantity: randAmount,
      maxParticles: randAmount,
    });
  }

  particleBurst() {
    this.emitter = this.scene.add.particles(this.scene.particleAtlas);
    this.emitter.createEmitter({
      frame: ["bluePart", "particleB2", "particleB3"],
      speed: { min: -175, max: 175 },
      alpha: { start: 0, end: 1 },
      scale: { start: Phaser.Math.Between(2, 3), end: 0 },
      blendMode: 'SCREEN',//{'SCREEN' || "ADD" || "MULTIPLY"},
      lifespan: Phaser.Math.Between(1250, 2500),
      alpha: { min: 0, max: 1 },
      maxParticles: 100
    });
    this.artifact.addAt(this.emitter, 0);
  }

  enableBtn() {
    this.checkBtn.setInteractive();
  }

  disableBtn() {
    this.checkBtn.disableInteractive();
  }

  tweenInWord() {
    this.scene.playSound("round_3_next_question");

    if (!gameData.gamePaused) {
      this.word.gainedFocus();
      this.scene.largePortal.enableKeys();
    }

    gameData.combined.push(gameData.combined.shift());

    this.txt.text = gameData.combined[0].present;
    this.txt.setPosition(this.wordBg.x, this.wordBg.y - 4);

    this.scene.addTween(this.txt, 750, { scaleY: 1 }, Phaser.Math.Easing.Quadratic.Out);
  }

  tweenInPortal() {
    this.scene.playSound("question_machine");

    this.scene.addTween(this, 2000, { y: 310 }, Phaser.Math.Easing.Quadratic.Out,
      () => {
        if (!gameData.gamePaused) this.enableBtn();
        this.word.gainedFocus();
      });
  }

  tweenOutPortal() {
    this.scene.playSound("question_machine");

    this.word.lostFocus();

    this.scene.addTween(this, 1000, { y: -150 }, Phaser.Math.Easing.Quadratic.In,
      () => { this.cleanUp(); });
  }

  cleanUp() {
    this.word.lostFocus();
    this.word.destroy();
    this.checkBtn.destroy();
    this.machine.destroy();
    this.wordBg.destroy();

    if (this.emitter) this.emitter.destroy();
    if (this.artifact) this.artifact.destroy();
  }
}